import React, { useEffect, useState } from 'react'
import { Facet, Value } from '../../search-spring/types/types'
import { checkActiveFilter, toggleFilter } from '../helpers/updateURLParams'

type Props = {
  filterValue: Value
  filter: Facet
}


const MobileFilterItem = ({filterValue, filter}: Props) => {

    // Need to check whether it is present or not in the url to determine if active or not. 
    const [filterActive, setFilterActive] = useState(false)

    const handleFilterClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
      toggleFilter(e)
      const filterStatus = checkActiveFilter(filter.field, filterValue.value)
      setFilterActive(filterStatus)
    }
  
    useEffect(() => {
      // Checks on load if the filter is in thr url and if it is set our state. 
      const filterStatus = checkActiveFilter(filter.field, filterValue.value)
      setFilterActive(filterStatus)
    },[])

    
  return (
    <a
    onClick={(e) => handleFilterClick(e)}
    data-field={filter.field}
    data-value={filterValue.value}
    className={`relative uppercase cursor-pointer font-calibre text-sm-b no-underline pt-SM ${filterActive ? 'text-black' : 'text-subdued'}`}
  >
    {filterActive &&
      <svg xmlns="http://www.w3.org/2000/svg" className='absolute left-[-11px] bottom-[5px] z-10' width="6" height="6" viewBox="0 0 10 8" fill="black">
        <circle cx="4" cy="4" r="4" fill="black"/>
      </svg>
    }
    {filterValue.label}
  </a>
  )
}

export default MobileFilterItem